import { render, staticRenderFns } from "./RsaPazientePrescrizioneBancaFarmaciComponent.vue?vue&type=template&id=2280e9f4&scoped=true"
import script from "./RsaPazientePrescrizioneBancaFarmaciComponent.vue?vue&type=script&lang=js"
export * from "./RsaPazientePrescrizioneBancaFarmaciComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2280e9f4",
  null
  
)

export default component.exports